'use client';

import { useToastStore, type Toast } from '@splace/core';

const ICONS: Record<Toast['type'], string> = {
  success: '✓',
  error:   '✕',
  info:    'ℹ',
  warning: '⚠',
};

const COLORS: Record<Toast['type'], string> = {
  success: 'var(--tier-2)',
  error:   'var(--accent)',
  info:    'var(--text-muted)',
  warning: 'var(--tier-3)',
};

export function Toaster() {
  const { toasts, remove } = useToastStore();

  if (!toasts.length) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24,
      display: 'flex', flexDirection: 'column', gap: 8,
      zIndex: 9999, maxWidth: 360,
    }}>
      {toasts.map(t => (
        <div
          key={t.id}
          className="animate-fade-in"
          style={{
            display: 'flex', alignItems: 'center', gap: 10,
            padding: '12px 16px',
            background: 'var(--bg-elev-2)',
            border: '1px solid var(--line)',
            borderLeft: `3px solid ${COLORS[t.type]}`,
            borderRadius: 'var(--r-md)',
            boxShadow: 'var(--shadow-pop)',
            fontSize: 13, color: 'var(--text)',
            cursor: 'pointer',
          }}
          onClick={() => remove(t.id)}
        >
          <span style={{ color: COLORS[t.type], fontWeight: 700, fontSize: 15, lineHeight: 1 }}>
            {ICONS[t.type]}
          </span>
          <span style={{ flex: 1, lineHeight: 1.4 }}>{t.message}</span>
        </div>
      ))}
    </div>
  );
}
